export default [
  {
    "id": "premiers-pas",
    "category": "Prise en main",
    "title": "Se repérer et choisir son rôle",
    "roles": [],
    "path": "",
    "summary": "Retrouvez les outils utiles à votre métier sans parcourir toute l’application.",
    "steps": [
      "Ouvrez le menu de votre profil, en haut à droite. Le rôle sélectionné détermine les menus et les fonctions proposés.",
      "Si plusieurs rôles vous sont attribués, choisissez celui correspondant au travail à effectuer. Un rôle absent doit être attribué par un administrateur.",
      "Utilisez la barre latérale pour ouvrir une fonctionnalité. Les points verticaux d’une ligne donnent accès à ses actions.",
      "Ouvrez Guide d’utilisation en bas de la barre latérale. Recherchez un mot ou choisissez une rubrique ; le contenu suit votre rôle actif.",
      "Les nouveautés sont accessibles depuis l’icône étoilée du header. Elles dépendent de l’interface utilisée."
    ],
    "tip": "Changer de rôle ne crée pas de nouveaux droits. Si une rubrique manque, vérifiez aussi que vous êtes dans la bonne interface : Clinique, Caisse ou Stock."
  },
  {
    "id": "session",
    "category": "Prise en main",
    "title": "Résoudre une session expirée ou un chargement impossible",
    "roles": [],
    "path": "",
    "summary": "Comprendre les messages d’accès et reprendre une opération sans la créer deux fois.",
    "steps": [
      "Si le message indique une session expirée, reconnectez-vous dans l’interface concernée. La session Clinique et la session Caisse sont distinctes.",
      "Après connexion, rouvrez la fonctionnalité et utilisez Réessayer si ce bouton est proposé.",
      "Si l’accès est refusé, vérifiez votre rôle actif et contactez un administrateur. Ne modifiez pas les données pour contourner un refus d’accès.",
      "Après une erreur au moment d’une validation, consultez d’abord la liste ou l’historique pour savoir si l’opération a été enregistrée avant de recommencer.",
      "Si le problème persiste, transmettez au support le nom de l’écran, l’heure et le texte exact du message, sans mot de passe ni données médicales inutiles."
    ],
    "tip": "Une liste vide n’est pas toujours une panne : effacez les filtres de recherche, de date ou de statut. Ne multipliez pas les clics sur Enregistrer pendant un chargement."
  },
  {
    "id": "rechercher-imprimer",
    "category": "Prise en main",
    "title": "Rechercher, filtrer et imprimer un document",
    "roles": [],
    "path": "",
    "summary": "Retrouver rapidement une ligne et vérifier ce qui sera imprimé.",
    "steps": [
      "Saisissez un nom ou une référence dans le champ Rechercher de la liste concernée.",
      "Choisissez le mois, la date ou le statut disponibles. Vérifiez la période affichée avant d’interpréter les totaux.",
      "Ouvrez les détails de la ligne ou son menu de points verticaux, puis l’option d’impression lorsqu’elle est proposée.",
      "Contrôlez l’identité, la référence, les montants et la période dans l’aperçu avant d’imprimer."
    ],
    "tip": "Si une ligne attendue est absente, retirez les filtres et vérifiez la pagination. N’envoyez un document contenant des données personnelles qu’à un destinataire autorisé."
  },
  {
    "id": "patient",
    "category": "Patients et accueil",
    "title": "Créer ou retrouver un patient",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT",
      "ROLE_ACCUEIL"
    ],
    "path": "/dashboard",
    "summary": "Éviter les doublons et compléter l’identité du patient.",
    "steps": [
      "Dans le tableau de bord, recherchez le patient avant de créer une nouvelle fiche.",
      "Ouvrez l’ajout de patient s’il n’existe pas. Choisissez Non assuré ou Assuré selon sa situation.",
      "Renseignez Nom & Postnom, Prénoms, sexe et les informations demandées. Vérifiez le téléphone et la date de naissance, ou l’âge lorsque la date n’est pas connue.",
      "Complétez, si nécessaire, les coordonnées de l’accompagnant et de la personne à prévenir, puis enregistrez.",
      "Vérifiez la fiche obtenue avant de préparer un bon ou une facture."
    ],
    "tip": "Pour un assuré, le malade et l’assuré principal peuvent être deux personnes différentes. Ne créez pas une deuxième fiche pour contourner un problème de couverture."
  },
  {
    "id": "assure",
    "category": "Patients et accueil",
    "title": "Enregistrer un patient assuré",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT",
      "ROLE_ACCUEIL"
    ],
    "path": "/dashboard",
    "summary": "Distinguer l’assuré principal du malade et vérifier la couverture.",
    "steps": [
      "Dans le formulaire patient, sélectionnez Assuré, puis l’assurance et la société correspondantes.",
      "Renseignez la validité, le taux de couverture et les informations de l’assuré principal.",
      "Dans Malade, choisissez Lui-même, Conjoint, Enfant ou Autre et complétez l’identité de la personne soignée.",
      "Vérifiez le matricule, les noms et les coordonnées avant d’enregistrer.",
      "Lors de la facturation, relisez la base assurance, la part assureur et la part patient calculées."
    ],
    "tip": "Un forfait mensuel peut ramener le paiement patient à zéro. Les exclusions et autorisations restent à vérifier ; ne remplacez pas une couverture par un montant saisi arbitrairement."
  },
  {
    "id": "bon-consultation",
    "category": "Patients et accueil",
    "title": "Préparer un bon de consultation",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT",
      "ROLE_ACCUEIL"
    ],
    "path": "/dashboard",
    "summary": "Orienter le patient vers la consultation choisie.",
    "steps": [
      "Recherchez le patient dans le tableau de bord et ouvrez l’action permettant de préparer son bon de consultation.",
      "Choisissez la consultation et le tarif proposés, puis contrôlez le patient et la prestation.",
      "Pour un assuré, vérifiez la société, la couverture et la répartition des montants avant la suite.",
      "À l’accueil, terminez l’étape autorisée de préparation ; à la caisse, poursuivez le paiement ou la validation proposée par votre rôle.",
      "Après confirmation, utilisez le bon généré ou son impression. Vérifiez sa référence avant de le remettre au patient."
    ],
    "tip": "Si le calcul tarifaire échoue, ne validez pas un montant de remplacement. Vérifiez les paramètres d’assurance avec l’administrateur et réessayez après correction."
  },
  {
    "id": "vente",
    "category": "Ventes et paiements",
    "title": "Vendre des prestations ou des articles",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/ventes",
    "summary": "Composer une vente avec les catégories utiles au patient.",
    "steps": [
      "Ouvrez Ventes et choisissez le patient.",
      "Cochez les catégories nécessaires dans Prestations / Services : analyses, examens, médicaments ou autres catégories disponibles.",
      "Utilisez Ajouter dans chaque catégorie. Choisissez les éléments et contrôlez les quantités ainsi que les prix unitaires.",
      "Pour un assuré, vérifiez les colonnes de couverture et le montant restant au patient.",
      "Poursuivez jusqu’au paiement. Relisez le récapitulatif avant la validation définitive, puis conservez la facture ou le ticket."
    ],
    "tip": "Le choix d’un prescripteur se fait dans la fenêtre Paiement lorsque l’option est activée. Le pourcentage ne remplace pas le tarif facturé au patient."
  },
  {
    "id": "facturation",
    "category": "Ventes et paiements",
    "title": "Facturer des opérations en attente",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/factures",
    "summary": "Regrouper les prestations déjà demandées pour un patient.",
    "steps": [
      "Ouvrez Factures, puis Nouvelle facture pour choisir un patient ayant des opérations.",
      "Sélectionnez le patient et vérifiez la période ainsi que le type d’opérations affichés.",
      "Choisissez les prestations à facturer et contrôlez les quantités, les prix et, le cas échéant, la part assurance.",
      "Ouvrez Paiement, renseignez les informations demandées et vérifiez le récapitulatif.",
      "Après confirmation, retrouvez l’opération dans Factures et utilisez l’impression proposée."
    ],
    "tip": "En cas de doute après une erreur réseau, consultez les factures existantes avant de relancer. Un paiement déjà confirmé ne doit pas être saisi comme une nouvelle vente."
  },
  {
    "id": "paiement-modes",
    "category": "Ventes et paiements",
    "title": "Comprendre le paiement total, partiel, différé ou à zéro",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/factures",
    "summary": "Distinguer le montant facturé, le montant reçu et le reste dû.",
    "steps": [
      "Dans la fenêtre Paiement, vérifiez le montant dû et la devise avant de saisir le montant réellement reçu.",
      "Pour un paiement total, contrôlez le reliquat ou la monnaie à remettre avant de continuer.",
      "Pour un paiement partiel, vérifiez le reste à payer dans le récapitulatif ; pour un différé, utilisez le mode prévu sans déclarer un encaissement fictif.",
      "Si l’assurance couvre entièrement le patient, le montant à payer peut être nul : contrôlez la prise en charge avant la validation.",
      "Validez une seule fois, attendez le résultat et vérifiez le ticket ou la facture générés."
    ],
    "tip": "Lorsque les commissions sont activées et un prescripteur choisi, la première validation déclenche la commission même en différé ou à zéro. Le règlement ultérieur du solde ne crée pas une deuxième commission."
  },
  {
    "id": "choisir-prescripteur",
    "category": "Ventes et paiements",
    "title": "Choisir un prescripteur et son indication clinique",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/factures",
    "summary": "Associer une prescription à la première validation d’une prestation.",
    "steps": [
      "Ouvrez Paiement depuis le bon ou la facture. Le bloc Médecin prescripteur apparaît si les commissions sont activées par l’administrateur.",
      "Recherchez le prescripteur par son nom ou son téléphone, puis sélectionnez-le dans la liste.",
      "Saisissez l’indication clinique demandée. Laissez Sans prescripteur uniquement si aucun prescripteur n’est associé à cette opération.",
      "Contrôlez les prestations et les informations de paiement, puis poursuivez jusqu’à la confirmation.",
      "Les commissions sont calculées sur PU × quantité × pourcentage de la catégorie configurée, y compris en partiel, différé ou prise en charge intégrale."
    ],
    "tip": "Si le bloc indique une session caisse expirée, reconnectez-vous à la Caisse. Une catégorie sans règle ou avec un taux nul ne génère pas de commission. Le guide ne permet pas de modifier une opération déjà validée."
  },
  {
    "id": "creer-prescripteur",
    "category": "Ventes et paiements",
    "title": "Ajouter un prescripteur depuis la caisse",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/factures",
    "summary": "Compléter le répertoire sans quitter la fenêtre Paiement.",
    "steps": [
      "Dans le bloc Médecin prescripteur, cliquez sur Ajouter un prescripteur.",
      "Renseignez son nom, ses prénoms et son téléphone.",
      "Ajoutez les catégories concernées, par exemple Analyses ou Examens, puis le pourcentage de chaque catégorie.",
      "Cliquez sur Enregistrer et sélectionner ; la nouvelle fiche devient le choix du paiement en cours.",
      "Renseignez l’indication clinique et relisez le paiement avant de le confirmer."
    ],
    "tip": "Choisissez des catégories, pas les analyses ou examens individuels. Vérifiez les taux convenus avant de les enregistrer ; une fiche sans règle ne produit pas de commission."
  },
  {
    "id": "proforma",
    "category": "Ventes et paiements",
    "title": "Préparer et retrouver une facture proforma",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/factures/facture-proforma",
    "summary": "Présenter les prestations envisagées avant la facturation définitive.",
    "steps": [
      "Ouvrez la liste des factures proforma et recherchez une proforma existante avant d’en créer une nouvelle.",
      "Dans le parcours de vente, composez les prestations du patient puis utilisez l’action de proforma proposée.",
      "Contrôlez l’identité, les quantités et les prix avant d’enregistrer ou d’imprimer le document.",
      "Lors de la reprise de la proforma en vente, vérifiez de nouveau les tarifs et la couverture avant le paiement."
    ],
    "tip": "Une proforma n’atteste pas d’un paiement. Utilisez la facture ou le ticket confirmé comme justificatif d’encaissement."
  },
  {
    "id": "depot",
    "category": "Caisse au quotidien",
    "title": "Enregistrer et consulter un dépôt",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/depots",
    "summary": "Retrouver les fonds déposés pour un patient.",
    "steps": [
      "Ouvrez Dépôt et recherchez le patient ou une opération existante.",
      "Pour un nouveau dépôt, sélectionnez le patient et renseignez les informations ainsi que le montant effectivement reçu.",
      "Vérifiez la devise, l’identité et le récapitulatif avant de confirmer.",
      "Contrôlez le dépôt dans la liste et conservez son justificatif."
    ],
    "tip": "Un dépôt n’est pas une vente de prestations. Vérifiez son utilisation dans le parcours de paiement plutôt que de saisir deux fois le même encaissement."
  },
  {
    "id": "reliquat",
    "category": "Caisse au quotidien",
    "title": "Suivre les reliquats",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/reliquat",
    "summary": "Retrouver un reliquat et consulter sa situation.",
    "steps": [
      "Ouvrez Reliquats et recherchez la personne ou la référence concernée.",
      "Vérifiez la période et le statut pour afficher les bonnes opérations.",
      "Ouvrez les détails ou les actions de la ligne et contrôlez le montant restant.",
      "Si un règlement est proposé à votre rôle, relisez le montant et le justificatif avant la confirmation, puis vérifiez l’historique."
    ],
    "tip": "Ne confondez pas un reliquat à remettre et une créance patient à encaisser. Consultez les détails de l’opération d’origine en cas de doute."
  },
  {
    "id": "ouverture",
    "category": "Caisse au quotidien",
    "title": "Ouvrir et suivre sa caisse",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/clinicaa/comptabilite/caisse",
    "summary": "Commencer la journée avec un état de caisse vérifié.",
    "steps": [
      "Ouvrez Caisse et vérifiez son état ainsi que la date de travail.",
      "Si une ouverture est nécessaire, utilisez le parcours d’ouverture et contrôlez le fonds de caisse renseigné.",
      "Après ouverture, consultez les mouvements et les soldes pour suivre les encaissements et sorties.",
      "Avant la clôture ou le versement, rapprochez les espèces physiques des mouvements affichés."
    ],
    "tip": "Ne lancez pas une seconde ouverture pour corriger un écart. Consultez les mouvements et contactez le responsable si le solde est incohérent."
  },
  {
    "id": "billetage",
    "category": "Caisse au quotidien",
    "title": "Faire le billétage et préparer un versement",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/clinicaa/comptabilite/caisse/versement",
    "summary": "Compter les espèces et expliquer un éventuel écart.",
    "steps": [
      "Dans Versement / Billétage, saisissez la quantité de chaque coupure pour chaque devise.",
      "Comparez le solde réel calculé au solde théorique, puis cliquez sur Continuer.",
      "Dans le rapport, vérifiez l’écart et renseignez un commentaire utile. Utilisez Recompter si nécessaire.",
      "Contrôlez le montant à verser et la destination.",
      "Relisez le rapport de versement et ses détails de billétage avant validation ; imprimez le justificatif si nécessaire."
    ],
    "tip": "Une différence de caisse doit être vérifiée et expliquée, pas masquée en modifiant le comptage. La réception du versement suit le parcours de trésorerie."
  },
  {
    "id": "sortie-caisse",
    "category": "Caisse au quotidien",
    "title": "Préparer un bon de sortie de caisse",
    "roles": [
      "ROLE_CAISSIERE",
      "ROLE_CAISSIERE_INTERMITENT"
    ],
    "path": "/clinicaa/comptabilite/caisse/sortie-bon",
    "summary": "Documenter une sortie avec sa destination et son motif.",
    "steps": [
      "Ouvrez le bon de sortie depuis la caisse.",
      "Renseignez les champs proposés, notamment le montant, le bénéficiaire et le motif.",
      "Vérifiez la devise, le solde disponible et toute autorisation requise avant de confirmer.",
      "Retrouvez le mouvement dans la caisse et conservez le bon associé."
    ],
    "tip": "Une autorisation requise ne doit pas être contournée en fractionnant l’opération. Faites vérifier la demande par le responsable habilité."
  },
  {
    "id": "tresorerie",
    "category": "Trésorerie et dettes",
    "title": "Lire les comptes et mouvements de trésorerie",
    "roles": [
      "ROLE_TRESORERIE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/tresorerie",
    "summary": "Comprendre les soldes, les entrées et les sorties sur la période choisie.",
    "steps": [
      "Ouvrez Trésorerie et sélectionnez le mois ou la date à consulter.",
      "Lisez les cartes des comptes de dépense, de dépôt, de banque et des dépenses en tenant compte de la période.",
      "Recherchez une référence ou un libellé pour retrouver le mouvement.",
      "Ouvrez les points verticaux de sa ligne pour consulter les actions disponibles et son détail.",
      "Utilisez Imprimer après avoir vérifié les filtres et les montants."
    ],
    "tip": "Les soldes de comptes et le total des dépenses ne représentent pas la même chose. Contrôlez aussi la source, la destination et le statut d’un mouvement."
  },
  {
    "id": "dettes",
    "category": "Trésorerie et dettes",
    "title": "Consulter les dettes et leurs détails",
    "roles": [
      "ROLE_TRESORERIE"
    ],
    "path": "/dettes",
    "summary": "Retrouver fournisseurs, prestataires et prescripteurs dans leurs onglets.",
    "steps": [
      "Ouvrez Dettes et choisissez Fournisseurs, Prestataires ou Prescripteurs.",
      "Filtrez par bénéficiaire, statut, mois ou date. Les cartes Montant dû, Payé, Restant à payer et Nombre de dettes suivent la sélection.",
      "Cliquez sur une ligne ou sur Détails dans les points verticaux pour ouvrir le popup.",
      "Pour une rémunération, contrôlez les prestations, le patient, la période et les montants détaillés.",
      "Consultez Historique lorsque vous devez retrouver les règlements déjà enregistrés."
    ],
    "tip": "Les dettes des prescripteurs sont regroupées par prescripteur et par mois. Une liste vide peut simplement venir des filtres ou de l’absence de prestation commissionnée."
  },
  {
    "id": "commissions-suivi",
    "category": "Trésorerie et dettes",
    "title": "Vérifier les commissions des prescripteurs",
    "roles": [
      "ROLE_TRESORERIE"
    ],
    "path": "/dettes",
    "summary": "Contrôler la base et le taux des commissions générées en caisse.",
    "steps": [
      "Ouvrez Dettes, puis l’onglet Prescripteurs.",
      "Choisissez le mois et recherchez le prescripteur concerné.",
      "Ouvrez sa ligne pour consulter les prestations à l’origine du montant dû.",
      "Pour chaque ligne, vérifiez le PU, la quantité et le taux de catégorie : commission = PU × quantité × taux / 100.",
      "Comparez la période et les totaux ; une reprise de paiement ne doit pas produire une deuxième commission."
    ],
    "tip": "La désactivation conserve les commissions acquises. La réactivation ne recalcule pas les anciennes opérations. Cet écran permet le suivi ; le règlement des dettes de prescripteurs n’est pas proposé dans ce parcours."
  },
  {
    "id": "payer-prestataire",
    "category": "Trésorerie et dettes",
    "title": "Préparer le paiement d’un prestataire",
    "roles": [
      "ROLE_TRESORERIE"
    ],
    "path": "/dettes",
    "summary": "Passer du détail de rémunération à la dépense correspondante.",
    "steps": [
      "Dans Dettes, ouvrez Prestataires et recherchez la rémunération à régler.",
      "Ouvrez les détails et contrôlez les prestations, la période et le restant dû.",
      "Si le bouton Payer est disponible, cliquez dessus pour ouvrir Dépenses avec la ligne Rémunération Prestataires présélectionnée.",
      "Vérifiez le bénéficiaire, le montant et le solde disponible avant de confirmer la dépense.",
      "Revenez à la dette pour vérifier le montant payé et son historique."
    ],
    "tip": "La ligne budgétaire de rémunération est protégée contre la suppression. Le bouton Payer n’est proposé que lorsque les conditions du règlement sont remplies."
  },
  {
    "id": "dotation",
    "category": "Trésorerie et dettes",
    "title": "Suivre les dotations",
    "roles": [
      "ROLE_TRESORERIE"
    ],
    "path": "/dotation",
    "summary": "Contrôler les fonds affectés aux besoins de l’établissement.",
    "steps": [
      "Ouvrez Dotation et recherchez l’opération ou la période voulue.",
      "Pour une dotation, choisissez la destination proposée et renseignez le montant ainsi que les informations requises.",
      "Vérifiez l’origine des fonds, le bénéficiaire et le solde avant la confirmation.",
      "Retrouvez l’opération enregistrée et consultez son détail pour le rapprochement."
    ],
    "tip": "Vérifiez les mouvements déjà saisis avant de répéter une dotation dont la confirmation a été interrompue."
  },
  {
    "id": "journal",
    "category": "Comptabilité et contrôle",
    "title": "Contrôler le journal de caisse",
    "roles": [
      "ROLE_TRESORERIE",
      "ROLE_COMPTABLE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/journal-caisse",
    "summary": "Retrouver les mouvements de caisse et leurs justificatifs.",
    "steps": [
      "Ouvrez Journal de caisse et choisissez la période de contrôle.",
      "Recherchez une référence, puis rapprochez le mouvement de son montant et de sa date.",
      "Ouvrez le détail ou le justificatif disponible dans les actions de la ligne.",
      "Vérifiez les totaux et les filtres avant toute impression ou rapprochement comptable."
    ],
    "tip": "Un écart doit être recherché dans les opérations d’origine. Évitez de créer un mouvement compensatoire sans en connaître la cause."
  },
  {
    "id": "produits",
    "category": "Comptabilité et contrôle",
    "title": "Analyser les produits d’exploitation",
    "roles": [
      "ROLE_COMPTABLE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/produits",
    "summary": "Lire les recettes par catégorie et par période.",
    "steps": [
      "Ouvrez Produits et sélectionnez la période de travail.",
      "Consultez les montants agrégés puis dépliez les catégories proposées pour examiner leur composition.",
      "Utilisez la recherche et les filtres pour retrouver les opérations attendues.",
      "Rapprochez les données des pièces d’origine avant de produire un rapport."
    ],
    "tip": "Comparez toujours des périodes et des devises identiques. Les filtres actifs peuvent expliquer une différence de total."
  },
  {
    "id": "charges",
    "category": "Comptabilité et contrôle",
    "title": "Consulter les charges",
    "roles": [
      "ROLE_COMPTABLE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/charges",
    "summary": "Retrouver les dépenses et comprendre leur classement.",
    "steps": [
      "Ouvrez Charges et choisissez la période.",
      "Recherchez la ligne ou la catégorie de dépense concernée.",
      "Ouvrez ses détails pour vérifier le libellé, la date et le montant.",
      "Rapprochez le total des justificatifs correspondants avant de finaliser votre contrôle."
    ],
    "tip": "Une charge et un transfert entre comptes ne sont pas nécessairement la même opération. Vérifiez le type et l’origine avant de conclure."
  },
  {
    "id": "creances",
    "category": "Comptabilité et contrôle",
    "title": "Suivre les créances et recouvrements",
    "roles": [
      "ROLE_COMPTABLE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/creance",
    "summary": "Identifier ce qui reste à encaisser.",
    "steps": [
      "Ouvrez Créances et sélectionnez les filtres utiles.",
      "Recherchez le patient, l’organisme ou la référence concernée.",
      "Consultez le montant initial, les règlements et le reste dû dans les détails disponibles.",
      "Utilisez le parcours de recouvrement autorisé pour enregistrer un règlement, puis vérifiez son historique."
    ],
    "tip": "Ne recréez pas une facture pour encaisser son solde. Reprenez la créance existante afin de conserver la traçabilité."
  },
  {
    "id": "budget",
    "category": "Administration financière",
    "title": "Gérer les lignes budgétaires",
    "roles": [
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/ligne-budgetaire",
    "summary": "Organiser les dépenses et leurs limites.",
    "steps": [
      "Ouvrez Ligne budgétaire et recherchez la ligne avant d’en ajouter une.",
      "Renseignez les informations et limites proposées pour la nouvelle ligne.",
      "Vérifiez son libellé et son utilisation avant d’enregistrer.",
      "Pour une modification, consultez les dépenses déjà rattachées et préservez les lignes système."
    ],
    "tip": "Rémunération Prestataires et les lignes système de commissions ne doivent pas être supprimées. Un plafond insuffisant doit être traité par le responsable, pas contourné."
  },
  {
    "id": "autorisations",
    "category": "Administration financière",
    "title": "Traiter les demandes d’autorisation et d’annulation",
    "roles": [
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/demande-autorisation",
    "summary": "Examiner les demandes avant de décider.",
    "steps": [
      "Ouvrez Demande autorisation ou Demande annul. dans la barre latérale.",
      "Recherchez la demande et consultez l’opération d’origine ainsi que le motif.",
      "Vérifiez le patient, les prestations, les montants et les conséquences attendues.",
      "Utilisez la décision proposée par l’écran seulement après ces contrôles, puis vérifiez le statut obtenu."
    ],
    "tip": "Une annulation peut affecter les états financiers. Ne la confirmez pas simplement pour faire disparaître une erreur d’affichage."
  },
  {
    "id": "coupons",
    "category": "Administration financière",
    "title": "Examiner les remises",
    "roles": [
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/coupons",
    "summary": "Contrôler les demandes de remise avant leur utilisation.",
    "steps": [
      "Ouvrez Remises et retrouvez la demande concernée.",
      "Consultez les informations de l’opération et la remise demandée.",
      "Vérifiez le motif et le montant avant d’utiliser les actions proposées.",
      "Contrôlez le statut de la remise et son application sur le récapitulatif de paiement."
    ],
    "tip": "Une remise ne change pas automatiquement le pourcentage de commission d’une catégorie : la commission utilise le PU et la règle configurée."
  },
  {
    "id": "param-caisse",
    "category": "Administration financière",
    "title": "Consulter les paramètres de la caisse",
    "roles": [
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/parametres",
    "summary": "Retrouver les réglages propres à cette interface.",
    "steps": [
      "Ouvrez Paramètres dans la barre latérale.",
      "Identifiez le réglage concerné et relisez sa valeur actuelle avant modification.",
      "Enregistrez uniquement les valeurs validées par votre établissement.",
      "Rouvrez le parcours concerné pour vérifier le résultat."
    ],
    "tip": "L’activation des commissions des prescripteurs se trouve dans l’interface Clinique, Établissement → Document et facturation, et non dans ces paramètres de caisse."
  },
  {
    "id": "controle-sorties",
    "category": "Portail",
    "title": "Contrôler la sortie d’un patient au portail",
    "roles": [
      "ROLE_AGENT_SECURITE",
      "ROLE_ADMINISTRATEUR"
    ],
    "path": "/portail/sorties",
    "summary": "Laisser sortir uniquement un patient libéré et à jour de paiement, puis pointer sa sortie.",
    "steps": [
      "Connectez-vous avec votre propre compte d’agent : l’écran Contrôle des sorties s’ouvre directement. L’administrateur l’ouvre depuis la barre latérale.",
      "Tapez trois lettres du nom, dans n’importe quel ordre, ou le numéro de dossier. La liste se filtre instantanément.",
      "Carte verte « À jour — peut sortir » : comparez le nom, le sexe, l’âge et le dossier avec la carte ou le ticket du patient, ou demandez son année de naissance.",
      "Touchez Sortie constatée puis confirmez. Le patient passe dans l’onglet Déjà sortis avec l’heure et l’agent qui a pointé.",
      "Bloc rouge « passage en caisse requis » : ne laissez pas sortir, orientez vers la caisse. Bloc orange « absent de la liste » : orientez vers le service ou l’accueil."
    ],
    "tip": "La liste s’actualise toute seule chaque minute. Si le bandeau rouge « Vérification des paiements indisponible » ou le badge gris « À revérifier » s’affiche, aucun patient n’est à laisser sortir : contactez la caisse. Déconnectez-vous en fin de poste."
  }
]
